var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUspLeaf = function SvgUspLeaf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 77 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 42,
    r: 22,
    fill: "#F4F3F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3278 56.2667C35.0013 56.266 29.8932 54.1496 26.127 50.3829C22.3609 46.6163 20.2451 41.5079 20.2451 36.1814C20.2451 7.05338 55.2958 22.0054 72.1704 8.00004C72.3515 7.86446 72.5662 7.78089 72.7913 7.75833C73.0164 7.73577 73.2434 7.77509 73.4478 7.87204C73.6554 7.95891 73.8376 8.09689 73.9774 8.27314C74.1173 8.44939 74.2103 8.65817 74.2478 8.88004C79.3998 39.048 57.1918 56.2667 40.3278 56.2667Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3627 30.8107C40.0423 33.0979 32.2454 36.9795 25.4053 42.2401L15 51.1201",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUspLeaf;